export enum ClientRegistrationStatus {
  Unregistered = "Unregistered",
  Registered = "Registered", 
  Disabled = "Disabled", 
}

export enum UploadSessionStatus {
  Queued = "Queued",
  InProgress =  "In progress",
  Completed = "Completed",
  Failed = "Failed"
}

export enum UploadType{
  ImportDataFile = "ImportDataFile",
  LiveView = 'LiveView'
}
